// https://usehooks-ts.com/react-hook/use-debounce
import { useEffect, useState } from 'react';
export const useDebounce = (value, delay, onDebounce) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      onDebounce === null || onDebounce === void 0 ? void 0 : onDebounce(value);
    }, delay || 500);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay, onDebounce]);
  return debouncedValue;
};
//# sourceMappingURL=useDebounce.js.map